import { Component, OnInit, HostListener, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { config } from 'src/app/app.config';
import { ShareData } from 'src/app/app.share-data';
import { ApiService } from 'src/app/services/api/api.service';
import { EventsService } from 'src/app/services/events.service';
import { NavigateService } from 'src/app/services/navigate/navigate.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { OneSignalService } from 'src/app/services/onesignal/one-signal.service';
import { CoreTranslateService, UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal/modal.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-navbar2',
  templateUrl: './navbar2.component.html',
  styleUrls: ['./navbar2.component.scss']
})

export class Navbar2Component implements OnInit {

  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-dialog-scrollable'
  };
  myProfile: any = {};
  logoUrl = "./assets/img/brand/logo_notext";
  themePrimaryColor = "#FFFFFF";
  themeSecondaryColor = "#FFFFFF";
  notifications: any = {};
  badge = 0;
  strFilter: any = '';
  apiData: any;
  isContentSeeAll = false;
  isServiceSeeAll = false;
  filterWording = this.coreTranslate.getWord('CONTENT.SEARCH_IN_CILA');
  isMarketplace = false;

  current_lang = localStorage.getItem("language");

  pdpaData: any = {};
  privacyPolicy: any = {};
  privacyPolicyUser: any = {};

  imgSrc = './assets/img/brand/logo.png';
  private resizeSubject: Subject<void> = new Subject<void>();

  constructor(
    private utility: UtilitysService,
    private ev: EventsService,
    private navigate: NavigateService,
    private modalServ: ModalService,
    private api: ApiService,
    private noti: NotificationService,
    private onesignal: OneSignalService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private router: Router,
    private location: Location,
    private coreTranslate: CoreTranslateService,
    private modalService: BsModalService,

  ) { }

  ngOnInit() {
    this.getMyProfile();
    this.getNotificationList();
    this.noti.notificationCount();
    //console.log('xxxxxx 9999999999999');
    //this.onesignal.initOneSignal();

    this.ev.onReloadMyProfile.subscribe(res => {
      this.getMyProfile(true);
    });

    this.ev.onNotificationCount.subscribe(res => {
      this.badge = res || 0;
    });
    this.strFilter = '';
    this.setFilterWording(window.location.href);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setFilterWording(event.urlAfterRedirects);
      }
    });

    //this.location.onUrlChange(url => {this.setFilterWording(url);});
    //this.getPrivacyPolicy();

    this.logoImg(); // Set the initial logo based on screen width
    this.resizeSubject.pipe(debounceTime(100)).subscribe(() => this.logoImg()); // Debounced resize handler

  }

  setFilterWording(url) {
    this.isMarketplace = false;
    // if(url.includes('/activity?')){
    //   this.filterWording = 'ค้นหากิจกรรม';
    // } else if(url.includes('/reward')){
    //   this.filterWording = 'ค้นหาของรางวัล';
    // } else 
    if (url.includes('/marketplace')) {
      this.filterWording = this.coreTranslate.getWord('PRODUCT.SEARCH_FOR_PRODUCTS');
      this.isMarketplace = true;
    }
    // else if(url.includes('/marketplace-my-store')) {
    //   this.filterWording = 'ค้นหาสินค้าในมาร์เก็ตเพลส';
    // } else if(url.includes('/store?')) {
    //   this.filterWording = 'ค้นหาสินค้าในมาร์เก็ตเพลส';
    // }
    //  else if(url.includes('/news?')) {
    //   this.filterWording = 'ค้นหาข่าว';
    // } else if(url.includes('/content?')) {
    //   this.filterWording = 'ค้นหาข่าว';
    // }
    else {
      this.filterWording = this.coreTranslate.getWord('CONTENT.SEARCH_IN_CILA');
    }
  }

  async getMyProfile(forceRefresh = false) {
    const expression: RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

    const newProfile = await this.utility.getMyProfile(true, true, false, forceRefresh);
    
    if (JSON.stringify(newProfile) !== JSON.stringify(this.myProfile)) {
      this.myProfile = newProfile;
      if (this.myProfile && this.myProfile.Email === 'null') {
         this.myProfile.Email = '';
      }
      this.logoUrl = this.myProfile.Template.LogoUrl;
      this.themePrimaryColor = this.myProfile.Template.PrimaryColor;
      this.themeSecondaryColor = this.myProfile.Template.SecondaryColor;
      var result: boolean = expression.test(this.myProfile.Email);
      if (!result) {
        this.navigate.navigateMenu('profile?type=edit');
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.resizeSubject.next();
  }

  logoImg() {
    if (this.isMobile()) {
      this.imgSrc = './assets/img/brand/logo_notext.png'; // Mobile version
    } else {
      this.imgSrc = './assets/img/brand/logo.png'; // Desktop version
    }
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  signout() {
    this.modalServ.onConfirm.emit({
      title: this.coreTranslate.getWord('MYSLEF.LOG_OUT'), content: this.coreTranslate.getWord('MYSLEF.CONFIRM_LOG_OUT'), callback: res => {
        if (res.status == 'confirm') {
          let username = window.localStorage.getItem(config.baseURL + '/username-other');
          window.localStorage.clear();
          window.localStorage.setItem(config.baseURL + '/username-other', username);
          this.navigate.navigateMenu('/signin', true);
        }
      }
    });
  }

  gotoMyProfile() {
    this.navigate.navigateMenu('profile?type=view');
  }

  gotoMyPoints() {
    // this.navigate.navigateMenu('mypoints');
    this.navigate.navigateMenu('all-points');
  }


  gotoHome() {
    this.navigate.navigateMenu('home');
  }

  gotoFavorite() {
    this.navigate.navigateMenu('favorite-list');
  }

  getNotificationList() {
    this.api.notificationListing().subscribe((res: any) => {
      if (res.Results != null && res.Results != undefined) {
        res.Results.Previous.forEach(function (item) {
          if (item.Detail != null && item.Detail != undefined) {
            item.Detail = removeStyleFromHTML(item.Detail.replace(/<[^>]*>/g, ''));
          }
        });
        res.Results.Today.forEach(function (item) {

          if (item.Detail != null && item.Detail != undefined) {
            item.Detail = removeStyleFromHTML(item.Detail.replace(/<[^>]*>/g, ''));
          }
        });
      }
      this.notifications = res.Results;
    });
  }


  onClickNotification(item: any, isToday: number) {
    // console.log(item);
    ShareData.currentService = item;
    item.isToday = isToday;
    if (item && ('MessageID' in item) && item.MessageID) {
      this.ngxUiLoaderService.start();
      this.api.notificationReading(config.oneSignalID, item.MessageID).subscribe((res: any) => {
        if (res.Code === 200) {
          this.getNotificationList();
          this.noti.notificationCount();
          this.ev.onServiceClick.emit({ item: item, isCheckEnable: true });
        } else {
          console.error(res);
        }
        this.ngxUiLoaderService.stopAll();
      }, (err: any) => {
        this.ngxUiLoaderService.stopAll();
        console.error(err);
      });
    }
  }

  filter(dropdown?: any) {
    this.apiData = null;
    // if(this.strFilter.trim().length > 0) {
    let url = this.router.url;
    this.checkUrl(url, dropdown, true);
    // }
  }

  allFilter() {
    let url = this.router.url;
    this.checkUrl(url);
  }

  async checkUrl(url: any, dropdown?: any, isMainFilter = false) {
    // if(url.includes('/activity?')){
    //   this.ev.onActivityFilter.emit({str: this.strFilter});
    // } else if(url.includes('/reward')){
    //   this.ev.onRewardFilter.emit({str: this.strFilter});
    // } else 
    if (url.includes('/marketplace') && !url.includes('/marketplace/')) {
      this.ev.onMarketHomeFilter.emit({ str: this.strFilter });
    } else if (url.includes('/marketplace-my-store')) {
      this.ev.onMyStoreFilter.emit({ str: this.strFilter });
    } else if (url.includes('/store?')) {
      this.ev.onStoreFilter.emit({ str: this.strFilter });
    }
    // else if(url.includes('/news?')) {
    //   this.ev.onNewsFilter.emit({str: this.strFilter});
    // } else if(url.includes('/content?')) {
    //   this.ev.onContentFilter.emit({str: this.strFilter});
    // }
    else {
      if (isMainFilter) {
        this.ngxUiLoaderService.start();
        this.apiData = await this.callServiceList();
        this.ngxUiLoaderService.stopAll();
        if (dropdown) {
          dropdown.open();
        }
      }
    }
  }

  callServiceList(): Promise<any> {
    return new Promise<any>((resolve: any) => {
      this.isContentSeeAll = false;
      this.isServiceSeeAll = false;
      this.api.serviceSearchList(this.strFilter).subscribe(res => {
        // console.log(res);
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          console.error(res);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  serviceSeeAll(pageSize = this.apiData.ServiceTotal): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.serviceSearch(this.strFilter, 1, pageSize).subscribe(res => {
        // console.log(res);
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          console.error(res);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  contentSeeAll(pageSize = this.apiData.ContentTotal): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.contentSearch(this.strFilter, 1, pageSize).subscribe(res => {
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          console.error(res);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  getServiceByCode(serviceCode: any): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.getServiceDetail(serviceCode).subscribe(res => {
        if (res.Code == 200) {
          resolve(res.Results);
        } else {
          console.error(res);
          resolve();
        }
      }, err => {
        resolve();
        console.log(err);
      });
    });
  }

  async serviceClick(item: any, dropdown: any) {
    let service = await this.getServiceByCode(item.ServiceCode);
    this.ev.onServiceClick.emit({ item: service, isCheckEnable: false });
    dropdown.close();
  }

  async serviceSeeAllClick() {
    this.ngxUiLoaderService.start();
    this.isServiceSeeAll = true;
    this.apiData.Service = await this.serviceSeeAll();
    this.ngxUiLoaderService.stopAll();
  }

  async contentSeeAllClick() {
    this.ngxUiLoaderService.start();
    this.isContentSeeAll = true;
    this.apiData.Content = await this.contentSeeAll();
    this.ngxUiLoaderService.stopAll();
  }

  async serviceSeeLessClick() {
    this.ngxUiLoaderService.start();
    this.apiData.Service = await this.serviceSeeAll(5);
    this.isServiceSeeAll = false;
    this.ngxUiLoaderService.stopAll();
  }

  async contentSeeLessClick() {
    this.ngxUiLoaderService.start();
    this.apiData.Content = await this.contentSeeAll(5);
    this.isContentSeeAll = false;
    this.ngxUiLoaderService.stopAll();
  }

  async contentClick(item: any, dropdown: any) {
    this.ev.onServiceClick.emit({ item: item, isCheckEnable: true });
    dropdown.close();
  }

  gotoNotificationList() {
    this.navigate.navigateMenu('notification-list');
  }
  //   getPrivacyPolicy(){
  //     this.api.getPrivacyPolicy().subscribe(res => {
  //        console.log(res);
  //        if(res.Code == 200) {
  //          this.pdpaData = res.Results;
  //        }
  //        console.log(this.pdpaData);
  //        if(this.pdpaData.PrivacyPolicy == null || this.pdpaData.PrivacyPolicy === null || typeof this.pdpaData.PrivacyPolicy === 'undefined' ){

  //        }
  //        else {
  //          this.privacyPolicy = this.pdpaData.PrivacyPolicy;
  //          if(this.pdpaData.PrivacyPolicyUser == null || this.pdpaData.PrivacyPolicyUser === null || typeof this.pdpaData.PrivacyPolicyUser === 'undefined' ){
  //           this.navigate.navigateMenu('privacy-policy', true);
  //          }
  //          else {
  //            if(this.pdpaData.PrivacyPolicy.ID ==  this.pdpaData.PrivacyPolicyUser.Id
  //               && this.pdpaData.PrivacyPolicy.Version ==  this.pdpaData.PrivacyPolicyUser.Version){

  //               }
  //               else {
  //                 this.navigate.navigateMenu('privacy-policy', true);
  //               }
  //          }
  //        }
  //     });
  //  }
  openAccountList() {
    this.modalServ.onOpenAccountList.emit();
  }

}
function removeStyleFromHTML(htmlString: string): string {
  // Parse the HTML string into a DOM object
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // Find all elements with the 'style' attribute
  const elements = doc.querySelectorAll('[style]');

  // Remove the 'style' attribute from each element
  elements.forEach(element => element.removeAttribute('style'));

  // Return the updated HTML as a string
  return doc.body.innerHTML;
}




